// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_COMMENT_DOES_NOT_BELONG_TO_FORUM = "Nahlasujem nevhodn\u00fa odpove\u010f";
export const MESSAGE_DOES_NOT_BELONG_TO_FORUM = "Nahlasujem nevhodn\u00fd pr\u00edspevok";
export const PHOTOBLOG_COMMENT_DOES_NOT_BELONG_TO_PHOTOBLOG = "Nap\u00ed\u0161, pre\u010do je koment\u00e1r nevhodn\u00fd.";
